var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollegeprojectAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-248",
    d: "M81.5,245.53c-93.06,53.73-93,140.84,0,194.56s243.93,53.73,337,0,93.05-140.83,0-194.56S174.56,191.81,81.5,245.53Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-248",
    d: "M435.25,311.22l-37,21.38c-2.44,1.4-6.69,1.23-9.5-.4L252.6,253.61c-2.81-1.62-3.11-4.08-.68-5.48l37-21.38c2.44-1.4,6.69-1.22,9.5.4l136.13,78.59C437.38,307.36,437.68,309.82,435.25,311.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M211.41,422.19l-124.65-72c-3.21-1.86-3.21-4.86,0-6.71l167-96.4a12.86,12.86,0,0,1,11.62,0l124.64,72c3.21,1.85,3.21,4.85,0,6.71L223,422.19A12.86,12.86,0,0,1,211.41,422.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M180.41,443.59c-.63,1.72-2.46,2.78-5.52,3.19l-50-29.22-5.66-5.74a.44.44,0,0,1,.45-.72l10.42,3.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-248",
    d: "M135.83,408.26l57.32,33.14,8.85,1.8a.27.27,0,0,0,.29-.4l-2.77-5.08L142.2,404.57C140.45,403.57,134.46,407.47,135.83,408.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-248",
    points: "336.79 451.17 449.47 386.11 376.23 343.82 263.54 408.88 336.79 451.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-248",
    cx: 90.49,
    cy: 387.31,
    rx: 33.04,
    ry: 19.08,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.54,399.57a1.06,1.06,0,0,1,.25.09l-.49-.28-.09-.05h0l-.1,0H141l-.08,0-.14,0h-.15a2.16,2.16,0,0,0-1.07.33,5.24,5.24,0,0,0-2.37,4.11,2.68,2.68,0,0,0,.06.59l0,.11s0,0,0,0a.56.56,0,0,0,0,.12,1.31,1.31,0,0,0,.19.35,1.22,1.22,0,0,0,.35.32l.57.32a1,1,0,0,1-.25-.2,1.91,1.91,0,0,0,1.36-.29,5.26,5.26,0,0,0,2.38-4.11A1.94,1.94,0,0,0,141.54,399.57Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,431.43l-3.35,5.83-.57-.33-54.38-31.42a1,1,0,0,1-.25-.2,1.88,1.88,0,0,1-.44-1.34,5.25,5.25,0,0,1,2.37-4.11,2.17,2.17,0,0,1,1.07-.32l.3,0a1.06,1.06,0,0,1,.25.09l0,0h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.11,431.6c1.31-.76,2.37-.14,2.37,1.37a5.22,5.22,0,0,1-2.37,4.11c-1.31.76-2.38.15-2.38-1.37A5.26,5.26,0,0,1,195.11,431.6Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.21,435.13l-.06-.07-3-3.33h0l0,0s0,0-.05-.06l0,0h0a1.54,1.54,0,0,0-1.9,0,5.26,5.26,0,0,0-2.38,4.11,1.54,1.54,0,0,0,.92,1.63h0l.17,0h0l4.39,1a1,1,0,0,0,.76-.17,3,3,0,0,0,1.36-2.35A1.06,1.06,0,0,0,200.21,435.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,410.31h0l-.08,0a.58.58,0,0,0-.55.08,1.86,1.86,0,0,0-.84,1.46.63.63,0,0,0,.19.51h0l.1.06,41.58,24,2.37-1.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,434.46l3.35,1.94,2.37-1.37-4.54-2.62A5.61,5.61,0,0,0,193,434.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,436.71h0l-2.75-3-.07-.08a1.07,1.07,0,0,0-1.36,0,3.71,3.71,0,0,0-1.68,2.9,1.11,1.11,0,0,0,.64,1.16h0l.11,0,4,.88h0a.64.64,0,0,0,.44-.09,1.69,1.69,0,0,0,.76-1.32A.61.61,0,0,0,201.41,436.71Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,436.71h0l-2.75-3-.07-.08a1.07,1.07,0,0,0-1.36,0,3.71,3.71,0,0,0-1.68,2.9,1.11,1.11,0,0,0,.64,1.16h0l.11,0,4,.88h0a.64.64,0,0,0,.44-.09,1.69,1.69,0,0,0,.76-1.32A.61.61,0,0,0,201.41,436.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.56,437.15a1.67,1.67,0,0,1-.77,1.32.6.6,0,0,1-.43.09h0l-2-.45c-.32-.07-.53-.37-.53-.85a2.72,2.72,0,0,1,1.22-2.12.8.8,0,0,1,1,0l.06.06,1.36,1.5h0A.61.61,0,0,1,201.56,437.15Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.8,436.71c.42-.25.76,0,.76.44a1.69,1.69,0,0,1-.76,1.32c-.43.24-.77,0-.77-.44A1.66,1.66,0,0,1,200.8,436.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.92,405.12a.59.59,0,0,0-.59.06,1.82,1.82,0,0,0-.84,1.46.56.56,0,0,0,.25.54h0l8.87,5.13a.63.63,0,0,1-.19-.51,1.86,1.86,0,0,1,.84-1.46.58.58,0,0,1,.55-.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,405.67a1.87,1.87,0,0,1-.84,1.45.59.59,0,0,1-.59.06.57.57,0,0,1-.25-.54,1.82,1.82,0,0,1,.84-1.46.59.59,0,0,1,.59-.06A.61.61,0,0,1,147.17,405.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.29,402.07h0l0,0,0,0-3.51-2-.08,0,0,0h0a1.51,1.51,0,0,0-1.45.18,4.7,4.7,0,0,0-2.13,3.7,1.49,1.49,0,0,0,.63,1.38h0l3.54,2h0a1.51,1.51,0,0,0,1.47-.16,4.75,4.75,0,0,0,2.14-3.71A1.52,1.52,0,0,0,145.29,402.07Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.29,402.07h0l0,0,0,0-3.51-2-.08,0,0,0h0a1.51,1.51,0,0,0-1.45.18,4.7,4.7,0,0,0-2.13,3.7,1.49,1.49,0,0,0,.63,1.38h0l3.54,2h0a1.51,1.51,0,0,0,1.47-.16,4.75,4.75,0,0,0,2.14-3.71A1.52,1.52,0,0,0,145.29,402.07Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.73,402.19c1.18-.68,2.14-.13,2.14,1.23a4.75,4.75,0,0,1-2.14,3.71c-1.18.68-2.13.12-2.13-1.24A4.72,4.72,0,0,1,143.73,402.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.53,438h0l-1.45-.87h0a.24.24,0,0,0-.28,0,.86.86,0,0,0-.4.67.28.28,0,0,0,.12.26h0l1.44.87h0a.5.5,0,0,0,.27.07.56.56,0,0,0,.56-.56A.58.58,0,0,0,202.53,438Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.61,438.05h0a.24.24,0,0,0-.08-.06h0a.3.3,0,0,0-.25,0,.84.84,0,0,0-.4.68.25.25,0,0,0,.11.24l0,0h0a.38.38,0,0,0,.18,0,.56.56,0,0,0,.56-.56A.54.54,0,0,0,202.61,438.05Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.66,410.67l-9.27-1.82a.3.3,0,0,0-.28.48l6.3,7.12Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.11,409.33a.3.3,0,0,1,.28-.48l1.81.36h0a1.57,1.57,0,0,0-.75,1.48v.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5,440l-.76-.43-.92-.53-39.41-22.59a4.22,4.22,0,0,1,.26-3.08c.66-1.48,1.93-2.64,3-2.71l39.39,22.59,1.75,1C169.63,433.68,166.33,439.41,167.5,440Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6,438.36l-1.69-1c-.5-.27-.22-1.5.37-2.77.77-1.69,2.3-3.32,3-3l1.25.72.44.26c-.66-.35-2.19,1.28-3,3-.56,1.22-.84,2.41-.42,2.73h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.18,438.12c-1.16-.62,2.17-6.36,3.33-5.74l1.7,1c-1.16-.61-4.49,5.12-3.33,5.74Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5,440l-1.68-1c-1.15-.59,2-6.15,3.23-5.79l.07,0,1.68,1C169.63,433.68,166.33,439.41,167.5,440Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07,409l.32-.16,6.73,3.69,41.3,23.69c.06-.11.12-.12.16,0-1,1.54-1.74,3.48-1.08,3.82l-.76-.43-.92-.53-39.41-22.59h0l-6.3-7.12A.31.31,0,0,1,120.07,409Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.61,444.08,167.5,440c-.5-.26-.23-1.47.35-2.74.77-1.69,2.28-3.34,3-3h0l7.14,4.08c1.41.82.11,3.9-1.47,5.27A1.7,1.7,0,0,1,174.61,444.08Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.18,441.87a5.15,5.15,0,0,1,2.91-3.51,1.15,1.15,0,0,1,1.06.15c1.07,1-.18,3.81-1.67,5.11a1.71,1.71,0,0,1-1.84.47C174.11,443.78,173.91,443,174.18,441.87Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-2--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-248"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M417.33,120.19v4.53s-1.74-1.59-1.84-2.74S417.33,120.19,417.33,120.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.85,119.1a4.74,4.74,0,0,0,3.49,6.05c4.94,1.55,8.05,0,8.79,1.38s-23.44,15.33-23.44,15.33l4.59-20Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.85,119.1a4.74,4.74,0,0,0,3.49,6.05c4.94,1.55,8.05,0,8.79,1.38s-23.44,15.33-23.44,15.33l4.59-20Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.77,310.36v.29l-9.47-5.49-94.59-54.24V65.44c0-2.89,1.58-4.31,3.53-3.18l3.53,2.05,97,56-.09.85Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.77,310.36v.29l-9.47-5.49-94.59-54.24V65.44c0-2.89,1.58-4.31,3.53-3.18l3.53,2.05,97,56-.09.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.64,147.42l-5.1-5.73,26-15c3.93,3,6.95,4.55,10.47,3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.27,123.58,314.2,68.12a6.61,6.61,0,0,0-6,0L282.49,82.94l97.42,55.75s4.21-1.09,7.08,1.22,2.7-.62,2.7-.62l21.89-12.64C409.8,124.26,410.27,123.58,410.27,123.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.76,146.22c-1-.57-1.42-1.23-.95-1.5l.81-.47c.91-.52.07-1.87-1.89-3s-4.28-1.64-5.19-1.11l-.82.47c-.47.27-2.17-.29-3.83-1.24l.59,180.13,2.43,1.39a2.19,2.19,0,0,0,1.42-.13l.81-.47c.91-.52,3.22,0,5.18,1.1s2.8,2.48,1.9,3l-.82.47c-.46.27,0,.93,1,1.51Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.76,146.22c-1-.57-1.42-1.23-.95-1.5l.81-.47c.91-.52.07-1.87-1.89-3s-4.28-1.64-5.19-1.11l-.82.47c-.47.27-2.17-.29-3.83-1.24l.59,180.13,2.43,1.39a2.19,2.19,0,0,0,1.42-.13l.81-.47c.91-.52,3.22,0,5.18,1.1s2.8,2.48,1.9,3l-.82.47c-.46.27,0,.93,1,1.51Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91,320.6v.28l-2.42-1.39L273.75,259.6l0-174.57c0-2.88,1.58-4.31,3.53-3.17l3.53,2,99.08,54.79Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91,320.6v.28l-2.42-1.39L273.75,259.6l0-174.57c0-2.88,1.58-4.31,3.53-3.17l3.53,2,99.08,54.79Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.62,325.34V145l6.44,2.6V327.35a6,6,0,0,1-3.56-.35Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.62,325.34V145l6.44,2.6V327.35a6,6,0,0,1-3.56-.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.73,306.63a1.45,1.45,0,0,1,0,.35.39.39,0,0,1-.05.23,2,2,0,0,1-.2.48,1.42,1.42,0,0,1-.12.25,4.83,4.83,0,0,1-.55.78,8.64,8.64,0,0,1-.72.78c-.29.26-.59.52-.91.78a5.19,5.19,0,0,1-.58.44l-.47.33c-.36.25-.74.49-1.15.73l-22.35,12.9a21.35,21.35,0,0,1-7.53,2.68V147.6l34.68-20.78V306.63Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.73,306.63a1.45,1.45,0,0,1,0,.35.39.39,0,0,1-.05.23,2,2,0,0,1-.2.48,1.42,1.42,0,0,1-.12.25,4.83,4.83,0,0,1-.55.78,8.64,8.64,0,0,1-.72.78c-.29.26-.59.52-.91.78a5.19,5.19,0,0,1-.58.44l-.47.33c-.36.25-.74.49-1.15.73l-22.35,12.9a21.35,21.35,0,0,1-7.53,2.68V147.6l34.68-20.78V306.63Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.06,162.5v21.67c13.86-4.71,25.75-11.1,34.68-20V142.47C419.81,151.4,407.92,157.79,394.06,162.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.06,283.21v21.67c13.86-4.71,25.75-11.1,34.68-20V263.18C419.81,272.11,407.92,278.5,394.06,283.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.6,144.92l-1.74-3a15.9,15.9,0,0,1-7.44,2.34,4.63,4.63,0,0,0-.61-2.94,9.14,9.14,0,0,0-3.35-3.08,13.42,13.42,0,0,0-5.07-1.72,2.48,2.48,0,0,0-.38,0,5.74,5.74,0,0,0-3.1.58l-92-53.12-3.13-1.79-4-2.31a2.13,2.13,0,0,0-2.17-.16l-3.53,2a2.16,2.16,0,0,1,2.21.13l.06,0L287.9,88l89,51.37c1.66,1,3.38,1.53,3.85,1.26l.81-.47a2.85,2.85,0,0,1,1.85-.12,10.08,10.08,0,0,1,3.33,1.21c2,1.14,2.8,2.49,1.9,3l-.81.47c-.47.27-.05.93.94,1.51l1.77,1C392.47,148.36,397.44,147.32,401.6,144.92Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.6,144.92l-1.74-3a15.9,15.9,0,0,1-7.44,2.34,4.63,4.63,0,0,0-.61-2.94,9.14,9.14,0,0,0-3.35-3.08,13.42,13.42,0,0,0-5.07-1.72,2.48,2.48,0,0,0-.38,0,5.74,5.74,0,0,0-3.1.58l-92-53.12-3.13-1.79-4-2.31a2.13,2.13,0,0,0-2.17-.16l-3.53,2a2.16,2.16,0,0,1,2.21.13l.06,0L287.9,88l89,51.37c1.66,1,3.38,1.53,3.85,1.26l.81-.47a2.85,2.85,0,0,1,1.85-.12,10.08,10.08,0,0,1,3.33,1.21c2,1.14,2.8,2.49,1.9,3l-.81.47c-.47.27-.05.93.94,1.51l1.77,1C392.47,148.36,397.44,147.32,401.6,144.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.86,141.9,422.2,129c.32-.19.63-.38.92-.57l.71-.51a.2.2,0,0,0,.07-.06c-2.56,1.11-6,0-8.3-1.28a8.84,8.84,0,0,1-3.28-3,4.67,4.67,0,0,1-.56-3.28l-.31-.18-.62-.35-89-51.36s-2.33-1.36-5.1-3c-.48-.27-1-.57-1.47-.84L311,62.12a2,2,0,0,0-1.93,0l1-.56,2.57-1.48a2,2,0,0,1,1.8,0s0,0,.05,0c.51.29,1,.61,1.59.91l1,.57c.58.35,1.17.68,1.71,1,.39.22.74.41,1.06.61s.53.3.75.43l1.32.75,70.66,40.82,22.57,13c1.61.91,2.55,1.88,2.17,2.2a1.15,1.15,0,0,1-.13.1l-.79.45c-1,.57-.19,1.94,1.77,3.07s3.5,1.15,4.47.63l1-.55a1.62,1.62,0,0,1,1.41-.21c.15.07.33.19.52.3s.69.4,1.11.64l1.39.8a1.4,1.4,0,0,1,.74,1.6.48.48,0,0,1-.05.23,2,2,0,0,1-.2.48h0a.82.82,0,0,1-.1.24,4.91,4.91,0,0,1-.56.78,10.22,10.22,0,0,1-.71.78c-.29.26-.59.51-.92.78a5.06,5.06,0,0,1-.57.44l-.47.33c-.36.25-.75.49-1.15.72L401.6,144.92Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.86,141.9,422.2,129c.32-.19.63-.38.92-.57l.71-.51a.2.2,0,0,0,.07-.06c-2.56,1.11-6,0-8.3-1.28a8.84,8.84,0,0,1-3.28-3,4.67,4.67,0,0,1-.56-3.28l-.31-.18-.62-.35-89-51.36s-2.33-1.36-5.1-3c-.48-.27-1-.57-1.47-.84L311,62.12a2,2,0,0,0-1.93,0l1-.56,2.57-1.48a2,2,0,0,1,1.8,0s0,0,.05,0c.51.29,1,.61,1.59.91l1,.57c.58.35,1.17.68,1.71,1,.39.22.74.41,1.06.61s.53.3.75.43l1.32.75,70.66,40.82,22.57,13c1.61.91,2.55,1.88,2.17,2.2a1.15,1.15,0,0,1-.13.1l-.79.45c-1,.57-.19,1.94,1.77,3.07s3.5,1.15,4.47.63l1-.55a1.62,1.62,0,0,1,1.41-.21c.15.07.33.19.52.3s.69.4,1.11.64l1.39.8a1.4,1.4,0,0,1,.74,1.6.48.48,0,0,1-.05.23,2,2,0,0,1-.2.48h0a.82.82,0,0,1-.1.24,4.91,4.91,0,0,1-.56.78,10.22,10.22,0,0,1-.71.78c-.29.26-.59.51-.92.78a5.06,5.06,0,0,1-.57.44l-.47.33c-.36.25-.75.49-1.15.72L401.6,144.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-1--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-248"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "337.13 444.88 440.93 384.95 374.62 346.66 270.81 406.59 337.13 444.88",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.13 444.88 440.93 384.95 374.62 346.66 270.81 406.59 337.13 444.88",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,414.12v-1.85c0-2.29,4.07-8.82,9.16-11.76L438,376.71V385Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,376.71l-41.23,23.81c-5.1,2.93-9.19,9.46-9.17,11.74l0,1.86L324.22,377.5h0l0-1.86c0-2.28,4.08-8.81,9.17-11.75l41.22-23.79h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,376.71l-41.23,23.81c-5.1,2.93-9.19,9.46-9.17,11.74l0,1.86L324.22,377.5h0l0-1.86c0-2.28,4.08-8.81,9.17-11.75l41.24-23.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.64,412.4l-3.95-2.29-5.2-3a10.2,10.2,0,0,1,6.4.93A5.35,5.35,0,0,1,387.64,412.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.64,412.4l-3.95-2.29-5.2-3a10.2,10.2,0,0,1,6.4.93A5.35,5.35,0,0,1,387.64,412.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.14 446.61 337.13 444.88 270.81 406.59 270.81 408.31 337.14 446.61",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.14 446.61 337.13 444.88 270.81 406.59 270.81 408.31 337.14 446.61",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.14 446.61 440.95 386.68 440.93 384.95 337.13 444.88 337.14 446.61",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.64,412.4c0-2.29-4.19-4.19-9.3-1.27l-41.22,23.62v8.54l50.53-29.17S387.66,414.69,387.64,412.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.12 443.29 337.12 434.75 273.69 398.13 273.69 406.67 337.12 443.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.35,411.13l-1.85,1.06-39.38,22.56-56-32.35-7.4-4.28,41.22-23.61c3.74-2.15,5.83-2,7.3-1.14h0l64.31,37.12C384.19,409.18,381.49,409.46,378.35,411.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.24 428.31 369.35 408.06 371.19 407 372.54 407.78 370.7 408.84 335.59 429.09 334.24 428.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331 426.44 366.1 406.19 367.95 405.13 369.3 405.91 367.45 406.96 332.35 427.22 331 426.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.76 424.57 362.86 404.31 364.71 403.26 366.06 404.04 364.21 405.09 329.11 425.35 327.76 424.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.51 422.7 359.62 402.44 361.47 401.39 362.82 402.17 360.97 403.22 325.87 423.48 324.51 422.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.27 420.82 356.38 400.57 358.23 399.51 359.58 400.29 357.73 401.35 322.62 421.61 321.27 420.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.03 418.95 353.14 398.7 354.98 397.64 356.33 398.42 354.49 399.48 319.38 419.73 318.03 418.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.79 417.08 349.89 396.83 351.74 395.77 353.09 396.55 351.25 397.61 316.14 417.86 314.79 417.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.55 415.21 346.65 394.95 348.5 393.9 349.85 394.68 348 395.74 312.9 415.99 311.55 415.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.31 413.34 343.41 393.08 345.26 392.03 346.61 392.81 344.76 393.86 309.66 414.12 308.31 413.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.06 411.47 340.17 391.21 342.02 390.16 343.37 390.94 341.52 391.99 306.42 412.25 305.06 411.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.82 409.6 336.93 389.34 338.77 388.28 340.13 389.06 338.28 390.12 303.17 410.38 301.82 409.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.58 407.72 333.69 387.47 335.53 386.41 336.88 387.19 335.04 388.25 299.93 408.5 298.58 407.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.34 405.85 330.44 385.6 332.29 384.54 333.64 385.32 331.79 386.38 296.69 406.63 295.34 405.85",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.1 403.98 327.2 383.73 329.05 382.67 330.4 383.45 328.55 384.5 293.45 404.76 292.1 403.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.86 402.11 323.96 381.85 325.81 380.8 327.16 381.58 325.31 382.63 290.21 402.89 288.86 402.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.61 400.24 320.72 379.98 322.57 378.93 323.92 379.71 322.07 380.76 286.96 401.02 285.61 400.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.37 398.37 317.48 378.11 319.32 377.05 320.68 377.83 318.83 378.89 283.72 399.15 282.37 398.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.74,408.92c-.76.07-2.38.59-3.26.79-3.75.85-10.37,3.86-16.7,7-8.46,4.23-16.43,8.75-16.43,8.75l-58-33.46,30.59-17.53a13.17,13.17,0,0,1,3.78-1.57,8.2,8.2,0,0,1,2.65.91l.41-.71a4,4,0,0,1,.46.23l64.31,37.12A10.42,10.42,0,0,0,378.74,408.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.08 436.61 343.38 433.42 337.12 437.23 330.84 433.6 337.08 436.61",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.13 440.89 348.67 434.23 337.13 440.44 324.16 433.39 337.13 440.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.69 400.01 283.39 405.86 273.69 400.91 273.69 400.01",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.7 403.35 288.11 412.15 273.69 404.14 273.7 403.35",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.49,407.1a21.81,21.81,0,0,0-2.48.42c-3.75.84-10.36,3.86-16.69,7-8.46,4.23-16.43,8.75-16.43,8.75l-63.47-36.6S303.57,372.81,313,371c4.45-.86,7.18-.26,8.84.68h0l63,36.38A10.2,10.2,0,0,0,378.49,407.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.69,403.87a10.23,10.23,0,0,0-6.41-.93,21.29,21.29,0,0,0-2.47.42,60.52,60.52,0,0,0-10.36,4c-2.07,1-4.22,2-6.33,3.06-5.1,2.55-10,5.2-13.12,6.91l1.45.83c3.1-1.71,8-4.36,13.11-6.91,2.12-1.06,4.26-2.11,6.33-3.06a61.38,61.38,0,0,1,10.36-4,21.66,21.66,0,0,1,2.47-.42,10.3,10.3,0,0,1,6.41.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.44,402a10.37,10.37,0,0,0-6.41-.93,24.31,24.31,0,0,0-2.47.43,60,60,0,0,0-10.36,4c-2.06.95-4.21,2-6.33,3-5.09,2.55-10,5.2-13.11,6.91l1.44.83c3.1-1.7,8-4.36,13.11-6.91,2.12-1.06,4.27-2.1,6.33-3.05a60.84,60.84,0,0,1,10.36-4,24,24,0,0,1,2.48-.43,10.34,10.34,0,0,1,6.4.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.19,400.12a10.2,10.2,0,0,0-6.4-.93,21.81,21.81,0,0,0-2.48.42,61.16,61.16,0,0,0-10.36,4c-2.06,1-4.21,2-6.33,3.06-5.09,2.55-10,5.2-13.11,6.91l1.44.83c3.11-1.71,8-4.36,13.11-6.91,2.12-1.06,4.27-2.11,6.33-3.06a61.16,61.16,0,0,1,10.36-4,21.81,21.81,0,0,1,2.48-.42,10.38,10.38,0,0,1,6.41.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,398.24a10.38,10.38,0,0,0-6.41-.93,23.84,23.84,0,0,0-2.47.43,60,60,0,0,0-10.37,4c-2.06.95-4.21,2-6.33,3-5.09,2.55-10,5.2-13.11,6.91l1.44.83c3.11-1.7,8-4.36,13.12-6.91,2.11-1.06,4.26-2.1,6.33-3.05a60.52,60.52,0,0,1,10.36-4,21.29,21.29,0,0,1,2.47-.42,10.31,10.31,0,0,1,6.41.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.7,396.37a10.23,10.23,0,0,0-6.41-.93,21.29,21.29,0,0,0-2.47.42,60.52,60.52,0,0,0-10.36,4c-2.07,1-4.21,2-6.33,3.06-5.1,2.55-10,5.2-13.12,6.91l1.45.83c3.1-1.71,8-4.36,13.11-6.91,2.12-1.06,4.26-2.1,6.33-3.06a61.71,61.71,0,0,1,10.36-4,21.66,21.66,0,0,1,2.47-.42,10.37,10.37,0,0,1,6.41.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,394.49a10.34,10.34,0,0,0-6.4-.93,24,24,0,0,0-2.48.43,60,60,0,0,0-10.36,4c-2.06.95-4.21,2-6.33,3-5.09,2.55-10,5.2-13.11,6.91l1.44.83c3.1-1.7,8-4.36,13.11-6.91,2.12-1.06,4.27-2.1,6.33-3.05a60.84,60.84,0,0,1,10.36-4,21.81,21.81,0,0,1,2.48-.42,10.28,10.28,0,0,1,6.4.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2,392.62a10.2,10.2,0,0,0-6.4-.93,21.81,21.81,0,0,0-2.48.42,61.16,61.16,0,0,0-10.36,4c-2.06,1-4.21,2-6.33,3.06-5.09,2.55-10,5.2-13.11,6.91l1.44.83c3.11-1.71,8-4.36,13.11-6.91,2.12-1.06,4.27-2.1,6.33-3.06a61.75,61.75,0,0,1,10.37-4,23.67,23.67,0,0,1,2.47-.42,10.38,10.38,0,0,1,6.41.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,390.74a10.38,10.38,0,0,0-6.41-.93,23.84,23.84,0,0,0-2.47.43,60.89,60.89,0,0,0-10.37,4c-2.06.95-4.21,2-6.33,3-5.09,2.55-10,5.2-13.11,6.91l1.44.83c3.11-1.7,8-4.36,13.12-6.91,2.11-1.06,4.26-2.1,6.33-3.05a60.52,60.52,0,0,1,10.36-4,21.29,21.29,0,0,1,2.47-.42,10.31,10.31,0,0,1,6.41.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.75,388.77a23.83,23.83,0,0,0-2.48.42c-3.75.85-10.36,3.87-16.69,7-5.09,2.55-10,5.2-13.11,6.91l-1.45-.83c3.11-1.71,8-4.36,13.12-6.91,6.33-3.18,12.94-6.19,16.69-7a21.66,21.66,0,0,1,2.47-.42,10.23,10.23,0,0,1,6.41.93l1.44.83A10.34,10.34,0,0,0,346.75,388.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.5,386.9a21.81,21.81,0,0,0-2.48.42c-3.75.84-10.36,3.86-16.69,7-5.09,2.55-10,5.21-13.11,6.91l-1.44-.83c3.1-1.71,8-4.36,13.11-6.91,6.33-3.17,12.94-6.19,16.69-7a24,24,0,0,1,2.48-.43,10.34,10.34,0,0,1,6.4.93l1.44.83A10.28,10.28,0,0,0,343.5,386.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.25,385a21.44,21.44,0,0,0-2.47.43c-3.75.84-10.36,3.86-16.7,7-5.09,2.55-10,5.2-13.11,6.91l-1.44-.83c3.11-1.71,8-4.36,13.11-6.91,6.33-3.17,12.95-6.19,16.69-7a21.81,21.81,0,0,1,2.48-.42,10.24,10.24,0,0,1,6.41.93l1.44.83A10.38,10.38,0,0,0,340.25,385Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,383.15a21.66,21.66,0,0,0-2.47.42c-3.75.84-10.36,3.86-16.69,7-5.1,2.55-10,5.21-13.12,6.91l-1.44-.83c3.11-1.71,8-4.36,13.11-6.91,6.34-3.17,12.95-6.19,16.7-7a23.84,23.84,0,0,1,2.47-.43,10.37,10.37,0,0,1,6.41.93l1.44.83A10.31,10.31,0,0,0,337,383.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.76,381.27a21.59,21.59,0,0,0-2.48.43c-3.75.84-10.36,3.86-16.69,7-5.09,2.55-10,5.2-13.11,6.91l-1.44-.83c3.1-1.71,8-4.36,13.11-6.91,6.33-3.17,12.94-6.19,16.69-7a21.66,21.66,0,0,1,2.47-.42,10.3,10.3,0,0,1,6.41.93l1.44.83A10.34,10.34,0,0,0,333.76,381.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.51,379.4a21.81,21.81,0,0,0-2.48.42c-3.75.84-10.36,3.86-16.69,7-5.09,2.55-10,5.2-13.11,6.9l-1.44-.83c3.1-1.71,8-4.36,13.11-6.91,6.33-3.17,12.94-6.19,16.69-7a24,24,0,0,1,2.48-.43,10.34,10.34,0,0,1,6.4.93l1.44.83A10.28,10.28,0,0,0,330.51,379.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.26,377.52a21.44,21.44,0,0,0-2.47.43c-3.75.84-10.36,3.86-16.7,7-5.09,2.55-10,5.2-13.11,6.91l-1.44-.83c3.11-1.71,8-4.36,13.11-6.91,6.33-3.17,13-6.19,16.69-7a21.81,21.81,0,0,1,2.48-.42,10.31,10.31,0,0,1,6.41.93l1.44.83A10.38,10.38,0,0,0,327.26,377.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,375.65a21.66,21.66,0,0,0-2.47.42c-3.75.84-10.36,3.86-16.69,7-5.1,2.55-10,5.2-13.12,6.9l-1.44-.83c3.11-1.71,8-4.36,13.12-6.91,6.33-3.17,12.94-6.19,16.69-7a23.84,23.84,0,0,1,2.47-.43,10.37,10.37,0,0,1,6.41.93l1.44.83A10.31,10.31,0,0,0,324,375.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.77,373.77a21.59,21.59,0,0,0-2.48.43c-3.75.84-10.36,3.86-16.69,7-5.09,2.55-10,5.2-13.11,6.91l-1.44-.83c3.1-1.71,8-4.36,13.11-6.91,6.33-3.17,12.94-6.19,16.69-7a21.66,21.66,0,0,1,2.47-.42,10.3,10.3,0,0,1,6.41.93l1.44.83A10.34,10.34,0,0,0,320.77,373.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.87,397.09a20.65,20.65,0,0,0-5.13,4.39l-1.32-.76a20.65,20.65,0,0,1,5.13-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.87,397.09a20.65,20.65,0,0,0-5.13,4.39l-1.32-.76a20.65,20.65,0,0,1,5.13-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.63,395.22a20.7,20.7,0,0,0-5.14,4.39l-1.32-.76a20.66,20.66,0,0,1,5.14-4.39l37-21.29,1.31.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.38,393.35a20.62,20.62,0,0,0-5.13,4.39l-1.32-.76a20.66,20.66,0,0,1,5.13-4.4l37-21.29,1.32.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.14,391.47a20.71,20.71,0,0,0-5.14,4.4l-1.31-.77a20.65,20.65,0,0,1,5.13-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.9,389.6a20.7,20.7,0,0,0-5.14,4.39l-1.32-.76a20.7,20.7,0,0,1,5.14-4.39l36.95-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.65,387.73a20.83,20.83,0,0,0-5.13,4.39l-1.32-.76a20.62,20.62,0,0,1,5.13-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.41,385.85a20.71,20.71,0,0,0-5.14,4.4l-1.32-.76a20.71,20.71,0,0,1,5.14-4.4l37-21.29,1.32.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.16,384a20.66,20.66,0,0,0-5.13,4.4l-1.32-.77a20.7,20.7,0,0,1,5.14-4.39l36.95-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.92,382.11a20.65,20.65,0,0,0-5.13,4.39l-1.32-.76a20.83,20.83,0,0,1,5.13-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.68,380.24a20.66,20.66,0,0,0-5.14,4.39l-1.32-.76a20.46,20.46,0,0,1,5.14-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.43,378.36a20.66,20.66,0,0,0-5.13,4.4L352,382a20.66,20.66,0,0,1,5.13-4.4l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.19,376.49a20.48,20.48,0,0,0-5.13,4.4l-1.32-.77a20.65,20.65,0,0,1,5.13-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,374.62a20.7,20.7,0,0,0-5.14,4.39l-1.32-.76a20.66,20.66,0,0,1,5.14-4.39l37-21.29,1.31.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.7,372.75a20.62,20.62,0,0,0-5.13,4.39l-1.32-.76a20.66,20.66,0,0,1,5.13-4.4l37-21.29,1.32.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.46,370.87a20.71,20.71,0,0,0-5.14,4.4l-1.31-.76a20.48,20.48,0,0,1,5.13-4.4l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.22,369a20.7,20.7,0,0,0-5.14,4.39l-1.32-.76a20.7,20.7,0,0,1,5.14-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,367.13a20.83,20.83,0,0,0-5.13,4.39l-1.32-.76a20.62,20.62,0,0,1,5.13-4.39l37-21.29,1.32.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.39 383.98 438.03 379.42 438.04 378.71 429.39 383.98",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.04 381.96 423.63 390.02 438.04 381.44 438.04 381.96",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31,381.28C297.1,377.17,307.54,372,313,371c4.45-.86,7.18-.26,8.84.68h0l63,36.38a10.2,10.2,0,0,0-6.4-.93s-31.19-19-51.33-25.52A64.9,64.9,0,0,0,289.31,381.28Z",
    style: {
      opacity: 0.02
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.83,152.22l0-16.55,13.91-1.46a1.3,1.3,0,0,1,.8.16l7.3,4.23a1.31,1.31,0,0,1,.29,2.05l-15,15.8Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.19,189.54V138.35a2.59,2.59,0,0,1,1.16-2l41.74-24.05a2.55,2.55,0,0,1,2.33,0l6.49,3.84a2.59,2.59,0,0,1,1.16,2v51.18a2.55,2.55,0,0,1-1.17,2l-41.74,24a2.53,2.53,0,0,1-2.32,0l-6.49-3.83A2.62,2.62,0,0,1,51.19,189.54Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,195.5c-.55.22-1-.09-1-.76V143.55a2.41,2.41,0,0,1,.34-1.15l-8.84-5.16a2.33,2.33,0,0,0-.31,1.11v51.19a2.59,2.59,0,0,0,1.16,2l6.49,3.83A2.55,2.55,0,0,0,61,195.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,138.44l-12,1.26V118.16c0-.75-.52-1-1.17-.68l-41.74,24a2.6,2.6,0,0,0-1.16,2v51.19c0,.74.52,1,1.16.67l41.74-24a2.55,2.55,0,0,0,1.17-2V154.41l13.08-13.76A1.31,1.31,0,0,0,116.07,138.44Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,138.44l-12,1.26V118.16c0-.75-.52-1-1.17-.68l-41.74,24a2.6,2.6,0,0,0-1.16,2v51.19c0,.74.52,1,1.16.67l41.74-24a2.55,2.55,0,0,0,1.17-2V154.41l13.08-13.76A1.31,1.31,0,0,0,116.07,138.44Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-248",
    d: "M94.62,131.55a3.67,3.67,0,0,0-4.79,1.95L76,166.41l-3.29-3.2a3.66,3.66,0,1,0-5.1,5.24l7.14,6.94a3.64,3.64,0,0,0,2.55,1,3.62,3.62,0,0,0,3.37-2.24l15.91-37.85A3.67,3.67,0,0,0,94.62,131.55Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.84,348.21l4.42-2.36-4-1A3,3,0,0,0,104.84,348.21Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.84,348.21l4.42-2.36-4-1A3,3,0,0,0,104.84,348.21Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.94,407.18a9.92,9.92,0,0,1-9,0L112,348.91,263.11,263.1l3.53-2,100.92,56.85c2.47,1.44,2.47,3.77,0,5.19Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.05,298.53l-35.19,20.25-22.79-13.15-26.5,15.31v17.69c0,2.31,2.59,5.61,3.54,5.07a26.06,26.06,0,0,1,5.07,1.79c3,1.38,7.31,5.42,7.31,5.42l80.87-45.28Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.05,298.53l-35.19,20.25-22.79-13.15-26.5,15.31v17.69c0,2.31,2.59,5.61,3.54,5.07a26.06,26.06,0,0,1,5.07,1.79c3,1.38,7.31,5.42,7.31,5.42l80.87-45.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.11,323.07v19.19l-.31-.19a9.07,9.07,0,0,0-4.31-1.34,4.51,4.51,0,0,0-2.84.66V318.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06,348.86a5.89,5.89,0,0,0-1.27-3.27,10.42,10.42,0,0,0-1.24-1.43l-.42-.4-.56-.47-.46-.35c-.33-.24-.67-.46-1-.67V323.16L119,326v-.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.57,338.63c0,2.31,2.59,5.61,3.54,5.07h0l3.54-2.3V326.8l-3.55-6.1-1.93-.69-1.6.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,382.73v21.91a6,6,0,0,1-3-.71l-11.08-6.39-84.32-48.68,0-22.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,300.44V317a6.67,6.67,0,0,1-3,5.19L231.5,397.54l-11.06,6.39a6,6,0,0,1-3,.71V385.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.11,234.63,112,321.86v2c0,1.12-1.57,1.54-3.51.41s-3.53-2.52-3.53-4.46l-.19-1.92,153.93-88.86.62-.36a2,2,0,0,1,.26.93v.93C259.61,231.69,261.17,233.49,263.11,234.63Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.11,234.63,112,321.86v2c0,1.12-1.57,1.54-3.51.41s-3.53-2.52-3.53-4.46l-.19-1.92,153.93-88.86.62-.36a2,2,0,0,1,.26.93v.93C259.61,231.69,261.17,233.49,263.11,234.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,380.14l-98.68-57c-1.26-.66-2.4-1.19-2.88-.94l.64-.36,151.08-87.23,1.76-1c1-.56,3.11-.25,4.76.71l97.93,56.54c2.47,1.44,2.47,3.77,0,5.19L221.94,380.14A10,10,0,0,1,213,380.14Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,228.7l-.62.36L104.8,317.92a1.17,1.17,0,0,0-.33-.42l-.52-.29-1.11-.64-1.36-.8a1.41,1.41,0,0,0-1.75.16.43.43,0,0,0-.17.16,2.65,2.65,0,0,0-.47.64,4.53,4.53,0,0,0-.4.86,9.74,9.74,0,0,0-.31,1c-.09.38-.15.77-.23,1.18a5.51,5.51,0,0,0-.08.71c0,.19,0,.36,0,.57,0,.43,0,.88,0,1.35v-4.32c0-2.39,2-5.49,4.49-6.93l145.63-84.08c2.49-1.44,6.07-1.68,8-.57l1.83,1.07.07,0c.12.08.44.26.78.45h0A1.56,1.56,0,0,1,259.35,228.7Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,407.18l-6.09-3.53L115.49,350.9a5.84,5.84,0,0,0-1.24-3.27,13.27,13.27,0,0,0-4-3.51,9,9,0,0,0-4.31-1.35,4.59,4.59,0,0,0-2.84.93,15.87,15.87,0,0,1-1.67-7.56H98c0,4.77,1.57,9.57,3.51,10.67l1.75,1c1,.57,1.76.6,1.76.06V347c0-1,1.57-1,3.53.14S112,350,112,351V352c0,.54,1.35,1.73,3,2.69l88.36,51,9.57,5.52h0a9.3,9.3,0,0,0,4.48,1.06v-4A9.08,9.08,0,0,1,213,407.18Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,407.18l-6.09-3.53L115.49,350.9a5.84,5.84,0,0,0-1.24-3.27,13.27,13.27,0,0,0-4-3.51,9,9,0,0,0-4.31-1.35,4.59,4.59,0,0,0-2.84.93,15.87,15.87,0,0,1-1.67-7.56H98c0,4.77,1.57,9.57,3.51,10.67l1.75,1c1,.57,1.76.6,1.76.06V347c0-1,1.57-1,3.53.14S112,350,112,351V352c0,.54,1.35,1.73,3,2.69l88.36,51,9.57,5.52h0a9.3,9.3,0,0,0,4.48,1.06v-4A9.08,9.08,0,0,1,213,407.18Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,380.15h0l-6.09-3.53L136.67,336.1l-22.41-12.94c-1.59-.93-2.89-1.26-3-.78a.07.07,0,0,0,0,.06v1c0,1.12-1.57,1.12-3.51,0S105,321,105,319.93v-1.11a1.61,1.61,0,0,0-.52-1.32l-.52-.29-1.11-.64-1.36-.8a1.41,1.41,0,0,0-1.75.16.43.43,0,0,0-.17.16,1.77,1.77,0,0,0-.31.41.94.94,0,0,0-.16.23,4.53,4.53,0,0,0-.4.86,9.74,9.74,0,0,0-.31,1c-.09.38-.15.77-.23,1.18a5.51,5.51,0,0,0-.08.71c0,.19,0,.36,0,.57,0,.43,0,.88,0,1.35v13.74h3.46V322.4c0-.36,0-.73,0-1.07l.09-.87a.22.22,0,0,1,0-.08c.31,2.75,3,5.2,5.23,6.5A8.63,8.63,0,0,0,111,328.2a4.66,4.66,0,0,0,3.1-1.15l.31.18.6.36,88.36,51,9.57,5.52a0,0,0,0,1,0,0s0,0,.07,0a9.31,9.31,0,0,0,4.41,1v-4A9.24,9.24,0,0,1,213,380.15Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,380.15h0l-6.09-3.53L136.67,336.1l-22.41-12.94c-1.59-.93-2.89-1.26-3-.78a.07.07,0,0,0,0,.06v1c0,1.12-1.57,1.12-3.51,0S105,321,105,319.93v-1.11a1.61,1.61,0,0,0-.52-1.32l-.52-.29-1.11-.64-1.36-.8a1.41,1.41,0,0,0-1.75.16.43.43,0,0,0-.17.16,1.77,1.77,0,0,0-.31.41.94.94,0,0,0-.16.23,4.53,4.53,0,0,0-.4.86,9.74,9.74,0,0,0-.31,1c-.09.38-.15.77-.23,1.18a5.51,5.51,0,0,0-.08.71c0,.19,0,.36,0,.57,0,.43,0,.88,0,1.35v13.74h3.46V322.4c0-.36,0-.73,0-1.07l.09-.87a.22.22,0,0,1,0-.08c.31,2.75,3,5.2,5.23,6.5A8.63,8.63,0,0,0,111,328.2a4.66,4.66,0,0,0,3.1-1.15l.31.18.6.36,88.36,51,9.57,5.52a0,0,0,0,1,0,0s0,0,.07,0a9.31,9.31,0,0,0,4.41,1v-4A9.24,9.24,0,0,1,213,380.15Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.41,293.41v4.06a3.1,3.1,0,0,1-1.78,2.56l-.07,0L231.5,378.62,222,384.14h0a9.32,9.32,0,0,1-4.48,1.06v-4a9.08,9.08,0,0,0,4.5-1.07l6.07-3.51h0l139.52-80.58A3.07,3.07,0,0,0,369.41,293.41Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.41,293.41v4.06a3.1,3.1,0,0,1-1.78,2.56l-.07,0L231.5,378.62,222,384.14h0a9.32,9.32,0,0,1-4.48,1.06v-4a9.08,9.08,0,0,0,4.5-1.07l6.07-3.51h0l139.52-80.58A3.07,3.07,0,0,0,369.41,293.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.41,320.45v4.06a3.1,3.1,0,0,1-1.78,2.56l-.07,0L231.5,405.66,222,411.18h0a9.32,9.32,0,0,1-4.48,1.06v-4a9.08,9.08,0,0,0,4.5-1.07l6.07-3.51h0l139.52-80.58A3.07,3.07,0,0,0,369.41,320.45Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.41,320.45v4.06a3.1,3.1,0,0,1-1.78,2.56l-.07,0L231.5,405.66,222,411.18h0a9.32,9.32,0,0,1-4.48,1.06v-4a9.08,9.08,0,0,0,4.5-1.07l6.07-3.51h0l139.52-80.58A3.07,3.07,0,0,0,369.41,320.45Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-248"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.8 303.91 222.8 371.12 379.73 281.06 261.74 213.84 104.8 303.91",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.8 303.91 222.8 371.12 379.73 281.06 261.74 213.84 104.8 303.91",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,367,109.24,301.36q3.6-10.19-.49-23.76L222.8,342.69S224.54,348.42,223.88,367Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12,335.26c4.87,2.79,8.81,9.58,8.81,15.16v17.71c0,5.58-3.94,7.84-8.81,5.05L104.81,308.3v-4.39l112.11,63.87c2.92,1.67,5.28.32,5.27-3l-.08-16.41a11.59,11.59,0,0,0-5.29-9.1l-112-63.89v-5Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.12,335.26c4.87,2.79,8.81,9.58,8.81,15.16v17.71c0,5.58-3.94,7.84-8.81,5.05L104.81,308.3v-4.39l112.11,63.87c2.92,1.67,5.28.32,5.27-3l-.08-16.41a11.59,11.59,0,0,0-5.29-9.1l-112-63.89v-5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.81,270.39l156.93-90.07,113.31,64.89c4.86,2.78,8.8,9.58,8.8,15.15v17.72c0,2.78-1,4.74-2.58,5.65L224.34,373.79c1.6-.91,2.58-2.87,2.58-5.65l0-17.73c0-5.57-3.95-12.36-8.81-15.15Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.81,270.39l156.93-90.07,113.31,64.89c4.86,2.78,8.8,9.58,8.8,15.15v17.72c0,2.78-1,4.74-2.58,5.65L224.34,373.79c1.6-.91,2.58-2.87,2.58-5.65l0-17.73c0-5.57-3.95-12.36-8.81-15.15Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36,341.79a17.85,17.85,0,0,1,2.58,8.62l0,17.73c0,2.78-1,4.74-2.58,5.65l156.93-90.06c1.6-.91,2.58-2.87,2.58-5.65V260.36a17.82,17.82,0,0,0-2.58-8.62Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36,341.79a17.85,17.85,0,0,1,2.58,8.62l0,17.73c0,2.78-1,4.74-2.58,5.65l156.93-90.06c1.6-.91,2.58-2.87,2.58-5.65V260.36a17.82,17.82,0,0,0-2.58-8.62Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.59,263.49c2.85,12.39,2.81,23.1,0,32.19l-7.29,4.21c2.81-9.09,2.85-19.8,0-32.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.35,323.66c2.86,12.4,2.82,23.11,0,32.2l-7.29,4.2c2.82-9.09,2.86-19.79,0-32.19Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-248"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.17,336.05l3.83-2.2s-2.2-.7-3.21-.23S198.17,336.05,198.17,336.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.54,333.64a4.64,4.64,0,0,1,6.83,0c3.72,3.42,3.91,6.81,5.45,6.75s1.52-19.73,1.52-19.73l-14.68,6.08Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.54,333.64a4.64,4.64,0,0,1,6.83,0c3.72,3.42,3.91,6.81,5.45,6.75s1.52-19.73,1.52-19.73l-14.68,6.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,238.5l.24-.14L347.25,233l-92.06-53.51L98.35,270.08c-2.44,1.41-2.88,3.44-1,4.54l3.45,2,94.69,54.69.67-.49Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,238.5l.24-.14L347.25,233l-92.06-53.51L98.35,270.08c-2.44,1.41-2.88,3.44-1,4.54l3.45,2,94.69,54.69.67-.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,307.76l-7.33-1.52V328c4.43,1.88,7.24,3.66,7.71,7.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.58,328.42l-93.8-54.15a6.52,6.52,0,0,1-3-5.11V247.79L195.54,303s1.13,4.09,4.49,5.38.8,2.6.8,2.6V328C197.93,327.69,197.58,328.42,197.58,328.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,306.75c-1-.56-1.73-.59-1.74-.06v.91c0,1-1.55,1-3.48-.13s-3.47-2.82-3.47-3.84v-.93c0-.52-1.31-1.7-2.92-2.63l152.61-87.45,2.37,1.38a2.23,2.23,0,0,1,.58,1.26v.92c0,1,1.55,2.74,3.45,3.84s3.47,1.16,3.47.14v-.92c0-.53.77-.49,1.74.07Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,306.75c-1-.56-1.73-.59-1.74-.06v.91c0,1-1.55,1-3.48-.13s-3.47-2.82-3.47-3.84v-.93c0-.52-1.31-1.7-2.92-2.63l152.61-87.45,2.37,1.38a2.23,2.23,0,0,1,.58,1.26v.92c0,1,1.55,2.74,3.45,3.84s3.47,1.16,3.47.14v-.92c0-.53.77-.49,1.74.07Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.37,214.14l.24-.14-2.36-1.37L246,154.15,98.35,239.39c-2.44,1.41-2.88,3.44-1,4.53l3.45,2,94.71,57Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.37,214.14l.24-.14-2.36-1.37L246,154.15,98.35,239.39c-2.44,1.41-2.88,3.44-1,4.53l3.45,2,94.71,57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.14,218.35l-152.49,88,5.34,4.17,152-87.75a5.87,5.87,0,0,0-2-2.84Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.14,218.35l-152.49,88,5.34,4.17,152-87.75a5.87,5.87,0,0,0-2-2.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,254.66a2.43,2.43,0,0,0,.28-.2.57.57,0,0,0,.17-.15,2.06,2.06,0,0,0,.3-.41,1.07,1.07,0,0,0,.15-.22,4.73,4.73,0,0,0,.4-.85,9.54,9.54,0,0,0,.3-1c.09-.37.16-.75.22-1.15a5.36,5.36,0,0,0,.09-.7c0-.19,0-.36.05-.56,0-.43,0-.87,0-1.33V230.48A21,21,0,0,0,362,222.8L210,310.56l-.65,31.9,152-87.77Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.09,298.38l18.32-10.58c2.79,14,3.19,19.62,0,31.53l-18.32,10.58C234.28,318,233.88,312.4,231.09,298.38Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.09,298.38l18.32-10.58c1.11,14.41,1.13,20.09,0,31.53l-18.32,10.58C232.21,316.28,232.05,311.14,231.09,298.38Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,283.88l6.83-3.95c2.79,14,3.19,19.62,0,31.53l-6.83,3.94C259.39,303.5,259,297.9,256.2,283.88Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,283.88l6.83-3.95a164.19,164.19,0,0,1,0,31.53l-6.83,3.94A140.75,140.75,0,0,0,256.2,283.88Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,236.05l6.83-3.94a165,165,0,0,1,0,31.53L339,267.58A140.84,140.84,0,0,0,339,236.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.39,318.25H208a15.41,15.41,0,0,0-1.65-7.43,4.49,4.49,0,0,1-2.79.92,8.89,8.89,0,0,1-4.23-1.33,13,13,0,0,1-3.93-3.45c-.07-.11-.16-.21-.21-.31a5.57,5.57,0,0,1-1-2.91l-89.84-51.87-3-1.77-3.9-2.24a2.06,2.06,0,0,1-1.19-1.76v-4a2.11,2.11,0,0,0,1.19,1.81l.05,0,10.31,5.94,86.88,50.17c1.62.93,2.94,2.11,2.94,2.63v.92a2.83,2.83,0,0,0,.8,1.62,10,10,0,0,0,2.66,2.23c1.92,1.1,3.47,1.15,3.47.13v-.92c0-.52.76-.49,1.73.07l1.72,1C209.85,308.84,211.39,313.56,211.39,318.25Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.39,318.25H208a15.41,15.41,0,0,0-1.65-7.43,4.49,4.49,0,0,1-2.79.92,8.89,8.89,0,0,1-4.23-1.33,13,13,0,0,1-3.93-3.45c-.07-.11-.16-.21-.21-.31a5.57,5.57,0,0,1-1-2.91l-89.84-51.87-3-1.77-3.9-2.24a2.06,2.06,0,0,1-1.19-1.76v-4a2.11,2.11,0,0,0,1.19,1.81l.05,0,10.31,5.94,86.88,50.17c1.62.93,2.94,2.11,2.94,2.63v.92a2.83,2.83,0,0,0,.8,1.62,10,10,0,0,0,2.66,2.23c1.92,1.1,3.47,1.15,3.47.13v-.92c0-.52.76-.49,1.73.07l1.72,1C209.85,308.84,211.39,313.56,211.39,318.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,318.25v17.62c0,.36,0,.71,0,1.05l-.09.86a.22.22,0,0,1,0,.08c-.31-2.7-2.9-5.12-5.14-6.4a8.63,8.63,0,0,0-4.15-1.29,4.6,4.6,0,0,0-3,1.12l-.3-.17-.6-.35L107.74,280.6l-5-2.88c-.46-.27-1-.54-1.43-.83l-4.2-2.43a2,2,0,0,1-.94-1.64v4a1.89,1.89,0,0,0,.87,1.53s0,0,0,0c.49.29,1,.58,1.55.9l1,.56,1.67,1c.37.22.71.43,1,.6s.51.3.74.42l1.27.75,69,39.83,22,12.72c1.56.92,2.84,1.24,2.92.77a.66.66,0,0,0,0-.17v-.89c0-1.1,1.55-1.1,3.46,0s2.68,2.4,2.72,3.47v1.09a1.57,1.57,0,0,0,.51,1.29,5.45,5.45,0,0,0,.51.29l1.09.63,1.34.78a1.37,1.37,0,0,0,1.72-.15.4.4,0,0,0,.17-.15,2.1,2.1,0,0,0,.31-.41v0a.8.8,0,0,0,.15-.2,4.7,4.7,0,0,0,.39-.85,9.55,9.55,0,0,0,.31-1c.08-.37.15-.75.22-1.15a5.35,5.35,0,0,0,.08-.7c0-.19,0-.36.05-.56,0-.43,0-.87,0-1.33V318.25Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,318.25v17.62c0,.36,0,.71,0,1.05l-.09.86a.22.22,0,0,1,0,.08c-.31-2.7-2.9-5.12-5.14-6.4a8.63,8.63,0,0,0-4.15-1.29,4.6,4.6,0,0,0-3,1.12l-.3-.17-.6-.35L107.74,280.6l-5-2.88c-.46-.27-1-.54-1.43-.83l-4.2-2.43a2,2,0,0,1-.94-1.64v4a1.89,1.89,0,0,0,.87,1.53s0,0,0,0c.49.29,1,.58,1.55.9l1,.56,1.67,1c.37.22.71.43,1,.6s.51.3.74.42l1.27.75,69,39.83,22,12.72c1.56.92,2.84,1.24,2.92.77a.66.66,0,0,0,0-.17v-.89c0-1.1,1.55-1.1,3.46,0s2.68,2.4,2.72,3.47v1.09a1.57,1.57,0,0,0,.51,1.29,5.45,5.45,0,0,0,.51.29l1.09.63,1.34.78a1.37,1.37,0,0,0,1.72-.15.4.4,0,0,0,.17-.15,2.1,2.1,0,0,0,.31-.41v0a.8.8,0,0,0,.15-.2,4.7,4.7,0,0,0,.39-.85,9.55,9.55,0,0,0,.31-1c.08-.37.15-.75.22-1.15a5.35,5.35,0,0,0,.08-.7c0-.19,0-.36.05-.56,0-.43,0-.87,0-1.33V318.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.22,260.21l7.87-18.82,22.3,8.81C265.17,261.93,254.26,276.07,252,281c0,0-11.8-1.71-14.06-7.48S242.25,262.41,245.22,260.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.69,268.31a9.65,9.65,0,0,0-2.36,3c-.66,1.17,0,6.52-.56,9.07s-1,3.25-2,6.46c-1.06,3.56-3.27,6.9.15,15.59s8.15,12.61,12,14.51a9.82,9.82,0,0,0,4.58.76s4.75-2.21,3.78-5.05S232.69,268.31,232.69,268.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,276.48c-.07.93-1.25,2.43-1.71,3.22-1.57,2.65-2.12,6.11-2.51,9.13-1.84,14.3,4.29,21-2.9,26.88-2.09,1.55-6.67,1.51-14.25-6.86-3.87-4.27-6.58-13.44-5.52-17.76s2.75-7.22,3.4-10.53-.26-9.33,1.32-12.25a13,13,0,0,1,4.12-4.11c1.28-.92,4.14-2.21,5.46-3.09s2-1.83,2.95-.9l-1.43,2.08c-2.22,3.6-1.49,4-1.3,5.87A28.4,28.4,0,0,1,242,274c1.59-2.35,2.17-4.34,4.11-4.14s2.17.09,5.11,2.47S254.92,275.66,254.86,276.48Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,276.48c-.07.93-1.25,2.43-1.71,3.22-1.57,2.65-2.12,6.11-2.51,9.13-1.84,14.3,4.29,21-2.9,26.88-2.09,1.55-6.67,1.51-14.25-6.86-3.87-4.27-6.58-13.44-5.52-17.76s2.75-7.22,3.4-10.53-.26-9.33,1.32-12.25a13,13,0,0,1,4.12-4.11c1.28-.92,4.14-2.21,5.46-3.09s2-1.83,2.95-.9l-1.43,2.08c-2.22,3.6-1.49,4-1.3,5.87A28.4,28.4,0,0,1,242,274c1.59-2.35,2.17-4.34,4.11-4.14s2.17.09,5.11,2.47S254.92,275.66,254.86,276.48Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.49,308.85c-3.87-4.27-6.58-13.44-5.52-17.76a40,40,0,0,1,1.32-4.22c0,.29-.1.59-.12.84,0,.55-.08,1.1-.09,1.66a12.68,12.68,0,0,0,1.18,6.34c.92,1.69,3.09,6,5.47,5.88,1.34,0,2.38-1.44,2.78-3,.17-.65.41-2.38.41-2.38a20.85,20.85,0,0,1,6.34,2c3.61,2,3.52,2.54,3.52,2.54a9.14,9.14,0,0,0,.11,3,7.58,7.58,0,0,0,1.5,2.91,5,5,0,0,0,.93.64c.1,3.25-.56,5.87-3.58,8.32C245.65,317.26,241.07,317.22,233.49,308.85Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,288.83a47.53,47.53,0,0,0,0,11.32c-1,3.7-2.17,3.68-2.47,1.82s1.62-9.79,3-16.34C250.93,286.72,250.77,287.8,250.64,288.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,266.89a7.86,7.86,0,0,1,1-5.26c.33-.18.63-.36.88-.52,1.42-1,2-1.83,2.95-.9l-1.43,2.08c-2.22,3.6-1.49,4-1.3,5.87A28.4,28.4,0,0,1,242,274c-1,6.22-2.14,8.36-2.39,14.19s1.2,9.62.41,10-2.49-.15-3.13-4.76.82-12.53,2-16.33S240.87,269.34,240.4,266.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.54,296.66a.64.64,0,0,0,.3.14c4.12.53,6.35,1.39,9.64,4.72a.58.58,0,1,0,.82-.81c-3.47-3.52-5.93-4.49-10.31-5.06a.58.58,0,0,0-.45,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.91,291.79a.64.64,0,0,0,.3.14,15.53,15.53,0,0,1,10.16,5.18.59.59,0,0,0,.84,0,.6.6,0,0,0,0-.84c-3.67-3.69-6.3-4.82-10.82-5.52a.59.59,0,0,0-.48,1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.42,286.49a.6.6,0,0,0,.33.16c4.7.73,7.52,2,11.36,5.83a.65.65,0,0,0,.92-.93c-4-4.06-7.1-5.42-12.08-6.19a.65.65,0,0,0-.75.54A.62.62,0,0,0,238.42,286.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.85,281.91a.73.73,0,0,0,.32.15c4.61.71,7.34,1.89,11.11,5.69a.66.66,0,0,0,.91,0,.65.65,0,0,0,0-.91c-4-4-6.94-5.29-11.82-6a.64.64,0,0,0-.73.54A.63.63,0,0,0,238.85,281.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18,277.37a.63.63,0,0,0,.33.15c4.61.72,7.33,1.9,11.11,5.69a.63.63,0,0,0,.9,0,.65.65,0,0,0,0-.91c-4-4-6.93-5.3-11.82-6.05a.63.63,0,0,0-.73.53A.64.64,0,0,0,240.18,277.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7,195.75s47.87-5.67,66.61-5.55c19.13.12,20.9,14.48,16.12,23.28-9.16,16.84-38.77,51.25-38.77,51.25s-11.9-3.6-15.19-12.86l6.21-16.66-37.07,5.11-6.75-4.86Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7,195.75s47.87-5.67,66.61-5.55c19.13.12,20.9,14.48,16.12,23.28-9.16,16.84-38.77,51.25-38.77,51.25s-11.9-3.6-15.19-12.86l6.21-16.66-37.07,5.11-6.75-4.86Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.44,248.24c-4.11-5.25-6.85-6.47-14.25-9l-4.72,12.66c3.29,9.26,15.19,12.86,15.19,12.86s3.42-4,8.28-9.87A73.35,73.35,0,0,0,267.44,248.24Z",
    style: {
      fill: "#FFAA28",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,219.46c-2.4,3.58-4.49,6.79-6.26,9.85s-7.29,4.56-12.88,3.41a107.33,107.33,0,0,1-19.25-6.3c3.13-5.74,2.53-12.75,2.53-12.75a25.26,25.26,0,0,1-8.51,13.67l1.4,9.72,2.67,3.26,31.9-4.4h0l5.18-.71c6.58-15.69,9.11-22.59,17.25-25.81C271.28,209.4,264.34,208.88,257.25,219.46Z",
    style: {
      fill: "#FFAA28",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,312.85l-17.51-18.7L282,279.24c8.05,12.47,15.9,24.39,21,29,0,0-3.39,11.42-9.83,12.09S283.69,316.46,282.31,312.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.45,324.1a10.16,10.16,0,0,0,2.36,3.21c1,1,6.55,1.85,9,3.1s3,1.94,6,3.8c3.28,2.06,6,5.22,15.73,4.2s15-4.69,18-8.07a10.33,10.33,0,0,0,2-4.4s-.9-5.39-4-5.21S286.45,324.1,286.45,324.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,304.07c.91.33,2.09,1.93,2.76,2.62,2.22,2.32,5.56,3.84,8.49,5.07,13.87,5.84,22.37,1.55,26.24,10.41,1,2.54-.34,7.14-10.87,12.44-5.38,2.71-15.37,2.87-19.43.6s-6.49-4.78-9.64-6.36-9.47-2.34-12-4.75a13.67,13.67,0,0,1-3-5.29c-.57-1.55-2.17-6.87-2.17-6.87,3,3.24,5.85,1.95,7.73,2.26a28.87,28.87,0,0,1,5.77,2.13c-1.92-2.26-3.76-3.4-3-5.3s.7-2.15,3.91-4.45S300.05,303.78,300.87,304.07Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.87,304.07c.91.33,2.09,1.93,2.76,2.62,2.22,2.32,5.56,3.84,8.49,5.07,13.87,5.84,22.37,1.55,26.24,10.41,1,2.54-.34,7.14-10.87,12.44-5.38,2.71-15.37,2.87-19.43.6s-6.49-4.78-9.64-6.36-9.47-2.34-12-4.75a13.67,13.67,0,0,1-3-5.29c-.57-1.55-2.17-6.87-2.17-6.87,3,3.24,5.85,1.95,7.73,2.26a28.87,28.87,0,0,1,5.77,2.13c-1.92-2.26-3.76-3.4-3-5.3s.7-2.15,3.91-4.45S300.05,303.78,300.87,304.07Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.49,334.61c-5.38,2.71-15.37,2.87-19.43.6a43.4,43.4,0,0,1-3.87-2.51c.29.12.57.27.81.36.54.2,1.09.38,1.65.55a13.31,13.31,0,0,0,6.7.59c2-.47,6.86-1.45,7.45-3.87.33-1.37-.79-2.8-2.22-3.63-.61-.36-2.29-1.08-2.29-1.08a22,22,0,0,1,3.84-5.81c3-3.06,3.53-2.83,3.53-2.83a9.8,9.8,0,0,0,3.08.73,7.94,7.94,0,0,0,3.34-.7,5.23,5.23,0,0,0,.9-.76c3.31.81,5.76,2.21,7.38,5.92C339.34,324.71,338,329.31,327.49,334.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.12,311.76A49.41,49.41,0,0,0,323.5,315c3.44,2.07,3.1,3.21,1.15,3s-9.41-4.36-15.61-7.58C310.07,310.88,311.12,311.34,312.12,311.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.18,316c-1.85-.14-3.29,0-4.87-.89-1-.5-1.58-2.81-1.53-3.84l1.64,1.73c2.78,1.24,4.73.94,6.61,1.25a28.87,28.87,0,0,1,5.77,2.13c6,2.72,7.82,4.48,13.61,6.36s10,1.48,10.19,2.38-.84,2.46-5.66,1.82-12.38-4.32-15.88-6.55S289.77,316.16,287.18,316Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.62,326.13a.67.67,0,0,0,.23-.27c1.68-4,3.17-6,7.44-8.38a.62.62,0,0,0,.23-.82.6.6,0,0,0-.82-.23c-4.51,2.5-6.17,4.71-8,9a.6.6,0,0,0,.32.79A.61.61,0,0,0,316.62,326.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.82,324.39a.58.58,0,0,0,.23-.26c1.85-4.11,3.55-6.26,8.05-8.78a.62.62,0,0,0,.24-.85.63.63,0,0,0-.85-.23c-4.74,2.66-6.6,5-8.57,9.35a.62.62,0,0,0,.9.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.36,323.41a.58.58,0,0,0,.24-.29c2-4.53,4.08-7,9-9.8a.69.69,0,0,0,.26-.93.68.68,0,0,0-.93-.26c-5.22,2.93-7.44,5.63-9.61,10.43a.69.69,0,0,0,.34.91A.7.7,0,0,0,306.36,323.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.86,321.7a.63.63,0,0,0,.24-.29c2-4.44,4-6.85,8.83-9.59a.67.67,0,0,0-.66-1.17c-5.11,2.87-7.27,5.51-9.39,10.22a.67.67,0,0,0,1,.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.67,319.09a.73.73,0,0,0,.24-.28c2-4.45,3.95-6.86,8.83-9.6a.68.68,0,0,0,.25-.91.66.66,0,0,0-.91-.25c-5.12,2.87-7.27,5.5-9.39,10.21a.67.67,0,0,0,.33.88A.68.68,0,0,0,297.67,319.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.28,293.79c-4.2,7.54-15.53,13.8-15.53,13.8s-4.82-4.36-16.41-13.8c-8.18-6.65-14.91-13.23-19.72-21.26-13.86-2.77-36.84-1.51-62.37-11.53-12.74-5-23.35-16.86-26-29.28a99.34,99.34,0,0,1-2.13-22.32c.23-22.77,73-12.06,73-12.06l-10.24,30s30.79,11.74,41.27,16.06c4.82,2,6.19,1.91,11.88,9.82C279.05,271.32,292.28,293.79,292.28,293.79Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.28,293.79c-4.2,7.54-15.53,13.8-15.53,13.8s-4.82-4.36-16.41-13.8c-8.18-6.65-14.91-13.23-19.72-21.26-13.86-2.77-36.84-1.51-62.37-11.53-12.74-5-23.35-16.86-26-29.28a99.34,99.34,0,0,1-2.13-22.32c.23-22.77,73-12.06,73-12.06l-10.24,30s30.79,11.74,41.27,16.06c4.82,2,6.19,1.91,11.88,9.82C279.05,271.32,292.28,293.79,292.28,293.79Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.07,305.54l.9-.61c-6.17-5.8-21.72-20.87-26.45-27.26-1.63-2.2-2.9-4.17-4-5.91-2.65-4.08-4.4-6.77-7.59-7.55-.68-.17-2.33-.5-4.81-1-12.67-2.6-46.32-9.49-58-15.81-.34-.19-.67-.4-1-.59,4-4,3.56-11.57.5-16.23-3.28-5-5.78-14.93-4-19.77l-1-.37c-2.11,5.64,1,16,4.07,20.72,2.87,4.38,3.18,11.63-.57,15.08-11.19-7-16.83-19.24-16.33-35.57l-1.06,0c-.55,17.7,6,30.73,18.85,37.7,11.82,6.4,45.58,13.32,58.29,15.92,2.39.49,4.12.84,4.78,1,2.78.68,4.43,3.24,6.95,7.1,1.13,1.75,2.42,3.73,4.07,6C258.64,285,274.34,300.14,280.07,305.54Z",
    style: {
      fill: "#FFAA28",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.1,78.15c-1.55-2.3-4.34-3.14-6.92-3.68-1-.22-1,1.94-.06,2.15,2.61.61,6,1.34,6.36,4.53a44.76,44.76,0,0,1,0,5.18c0,1.73,0,3.46,0,5.19q0,5.17-.05,10.35c0,3.65-.19,7.34,0,11,.06.89,1.73,2.11,1.85.7.35-4.09.16-8.27.18-12.37s.08-8.17.09-12.25C212.53,85.47,213.15,81.19,211.1,78.15Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.48 80.52 189.14 49.86 187.21 49.5 144.4 84.77 169.66 115.43 171.59 115.8 214.48 80.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.14 49.86 146.32 85.13 171.59 115.8 214.48 80.52 189.14 49.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,98.85a7.61,7.61,0,0,1-.59,5.63,8,8,0,0,1-4.33,3.18c-3,1.15-5.6,2.25-7.51,4.37-2.39,2.65-3,5.53-2.51,9.78a1.36,1.36,0,0,1-.31,1.06,1.77,1.77,0,0,1-.71.4,14.57,14.57,0,0,0-8.26,8.81c-1.38,3.88-1.75,9.31.26,13a19.73,19.73,0,0,0,6.67,7.21c5.7,3.73,12.72,5.16,19.4,5.83l1.14.11c14.9,1.29,32,1.67,45.15-5.41,6.5-3.48,13.43-7.27,14.25-18.17a15.42,15.42,0,0,0-10.82-16.26c1.51-2.72,3-4.83,1.51-9.22-.94-2.73-3.65-4.82-5.88-6.63s-3-3.68-3.25-6.72a29.71,29.71,0,0,1,.26-5.32c2.12-1.08,2.39-4.09,1.77-6.17,0,0-1.9-5.23-1.95-5.31-3.24-4.45-8.13-6.47-13.43-7-4.55-.41-8.91-1-13.45,0a28.54,28.54,0,0,0-12.25,6A18,18,0,0,0,162.59,82a16.7,16.7,0,0,0-2.32,6.42,23.1,23.1,0,0,0,.21,8.37C160.62,97.46,160.79,98.15,161,98.85Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-248",
    d: "M200.76,124.55c13.18-2.25,17.45,7.54,18.59,13.7,1.31,7.08,1.16,23.72,1.16,23.72l19.13,13.38-6.75,12.41s-17.27-7.55-23-10.39c-6.32-3.12-5.49-5.09-6.36-14.85S200.31,130.15,200.76,124.55Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.43,218.49c.21-2.75-1.39-25.9.68-47.1.66-6.78,7.43-35.6,9.1-40.7l13.36-3.79s11.63-1.46,26-2.2l3.18-.15c.91.92,15,11.21,19.33,22.56,2.08,5.47,2.23,19.36,2.44,29.63.22,10.46,1.33,13.54,3.55,15-1.51,11.31-17.38,25.13-36.42,29.54C166.79,226.54,149.86,219.32,148.43,218.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.43,218.49c.41,21.08,4.86,29,15.56,37.55,11.6,9.26,34.58,13.35,44.92,14.34,14.13,1.33,29.28,1.72,29.28,1.72s-1.31-15.26,5.71-25.47,29.21-47.32,52.73-54.45c-4.24-3.29-11.67-3.45-36.43-1.22s-33.55,3.24-37-1.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.28,146.54a24.1,24.1,0,0,0,6.24-4.49c-.45-.73-.93-1.44-1.43-2.14-.23.27-.47.53-.73.79a21.32,21.32,0,0,1-4.57,3.31,50.27,50.27,0,0,1-12,4.64,71.64,71.64,0,0,1-27.41,1.1,112.57,112.57,0,0,1-15.81-3.46c-1-.28-1.25,1.78-.43,2C173.19,153.63,194,155.64,211.28,146.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.78,234v1.26a3.57,3.57,0,0,0,1.77,3.09l33.89,19.7a3.5,3.5,0,0,0,1.78.48,3.63,3.63,0,0,0,1.78-.46l62.48-35.71a3.56,3.56,0,0,0,1.79-3.08v-.87l-66,37.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.27,218.41l-36.86-21.49a2.11,2.11,0,0,0-2.13,0L193,233.65a.47.47,0,0,0,0,.81l37.21,21.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.89 253.03 210.01 241.44 268.44 208.05 288.42 219.57 229.89 253.03",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.24 221 220.6 221.22 230.35 226.9 247.76 216.94 248.13 216.74 238.01 210.85 220.24 221",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.6 221.22 230.35 226.9 247.76 216.94 238.01 211.26 220.6 221.22",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.22,256.16v2.37a3.63,3.63,0,0,0,1.78-.46l62.48-35.71a3.56,3.56,0,0,0,1.79-3.08v-.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M256.16,198a5.29,5.29,0,0,1,.52,1.07c.57,1.45,1.17,2.84,1.77,4.27a8.94,8.94,0,0,0,1.65,2.77c.63.64,2.58,1.87,3.26.71a1.26,1.26,0,0,0,0-.88c-.24-1.25-.54-2.48-.84-3.71-.13-.53-.51-2.14,0-2.52a1.17,1.17,0,0,1,.49-.15,3.33,3.33,0,0,0,2-1.15,1.52,1.52,0,0,1,.41-.39,2.09,2.09,0,0,1,.75-.08,1.64,1.64,0,0,0,1.11-.64,2.17,2.17,0,0,0,.33-.57,4.84,4.84,0,0,0,.25-1.82c0-1.16-.05-2.32-.11-3.48a6.23,6.23,0,0,0-.21-1.49c-.38-1.21-1.53-2.07-2.41-2.94-1-1-2.1-2-3.22-2.92a9.44,9.44,0,0,0-2.81-1.91,21.71,21.71,0,0,0-3.48-.81A51.25,51.25,0,0,1,245,178.2c-.43-.18-3.85-2-5.37-2.85-4.54,3.59-7.13,7.65-6.75,12.41a35.53,35.53,0,0,1,3.81,2.55,20.15,20.15,0,0,1,4.25,4.25,20.29,20.29,0,0,0,3.15,3.7c2.08,1.72,4.87,2.41,6.85,4.24a2.84,2.84,0,0,0,1.52,1A1.62,1.62,0,0,0,254,202a4.12,4.12,0,0,0-.6-2.27,19.82,19.82,0,0,0-2.8-4.1c1.74-.38,4.13.76,5.29,2.07A2.52,2.52,0,0,1,256.16,198Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.45,189.85c1.12-16.54,2.46-28.24,4.05-40.47,1-7.45,5-14.9,15.58-18.16,9.22,5.69,8.69,24.95,7.75,29.63l-4.1,29.35s4.8,3.39,13.22,8.93c7,4.64,11.7,8.74,19.77,9.16s11.3-.06,15.59,1.48c2.29.81,7.51,2.72,9.3,3.48s5.09,3.69,8.1,5.61c2.84,2-.45,3.38-2.59,2.91a27.09,27.09,0,0,1-6.49-2.64,36.83,36.83,0,0,0-5.54-1.7,32,32,0,0,1,1.56,6.22c.09,1.15.43,2.53-.52,3.44a8.67,8.67,0,0,1-2.34,1.16,1.72,1.72,0,0,1-.4,1.14,2.87,2.87,0,0,1-2,.66,8.77,8.77,0,0,1-1.18-.09A2.12,2.12,0,0,1,207,231.7a9.36,9.36,0,0,1-4.9.5c-.25-.08-2.14-.95-2.7-1.19a4.91,4.91,0,0,1-1.88-1c-.44-.57.59-2,1.52-2.24a9.69,9.69,0,0,1,3.14,0,11,11,0,0,1-1.09-2.63c-.94-1.31-7,.49-12.52-.1-4.17-.44-7.41-4.16-9.32-4.87C167,215.58,160.58,214,147.89,208,137.44,203.07,137.86,198.59,138.45,189.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.18,217.72c-.74-1.51-1.83-3.3-3.05-3.65a13.86,13.86,0,0,1,2,3.36C213.46,217.54,213.82,217.63,214.18,217.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.79,228.25a13,13,0,0,0-.12-3.41,31.61,31.61,0,0,0-.66-3.33,14.37,14.37,0,0,0-1.14-3.24,6.23,6.23,0,0,0-2.21-2.58,4.82,4.82,0,0,1,1,1.31,11.48,11.48,0,0,1,.74,1.49,23.43,23.43,0,0,1,1,3.18c.28,1.08.54,2.18.8,3.27A28,28,0,0,1,211.79,228.25Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.19,230a15.55,15.55,0,0,0-.22-3.34,28.45,28.45,0,0,0-.71-3.27,22.32,22.32,0,0,0-1.13-3.15,6.42,6.42,0,0,0-1.89-2.75,4.18,4.18,0,0,1,.84,1.4c.22.5.41,1,.59,1.53.34,1,.67,2.09,1,3.15C207.22,225.65,207.79,227.77,208.19,230Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.05,227.75a5.7,5.7,0,0,1,1.4.1c.45.08.78.28,1.35.42l-.25-.35a1.34,1.34,0,0,0,.13.66,1.57,1.57,0,0,0,.35.49,1.9,1.9,0,0,0,1,.55,4.12,4.12,0,0,1-.62-.82,1.85,1.85,0,0,1-.17-.42,1.11,1.11,0,0,1,0-.38v-.26l-.26-.09a4.19,4.19,0,0,0-1.32-.19A2.79,2.79,0,0,0,199.05,227.75Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.21,130.69c-4.81.35-12.16,2.34-15,7s-2.7,17.46-3.51,25.66c-1,10.22-1.95,20.77-2.55,28.82-.42,5.8-.29,9.91,3,12.79s25.19,10.21,25.19,10.21c.1-4.12,3.46-13.78,8.44-16.85l-11.11-8.44,4.17-30.36S169.67,135.6,158.21,130.69Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.22,256.69a4.24,4.24,0,0,0,3.64-.26l62.2-35.56a4.21,4.21,0,0,0,2.07-2.94l7-40.48a4,4,0,0,0,.06-.69,4.2,4.2,0,0,0-1.24-3l-64.64,37a3.12,3.12,0,0,0-1.53,2.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.22,256.16l.42.25a4.41,4.41,0,0,0,.58.28l7.53-43.81a3.12,3.12,0,0,1,1.53-2.17l64.64-37a4,4,0,0,0-.86-.66l-64.77,37a3.12,3.12,0,0,0-1.53,2.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.43,218.8c.47-2.71,3.28-6.3,6.29-8s5.07-.91,4.6,1.8-3.28,6.3-6.29,8S264,221.51,264.43,218.8Z",
    style: {
      fill: "#FFAA28"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.74,111.13a7.15,7.15,0,0,1-6.46-2.23c-3.47-3.56-3.88-7.26-2.37-9.77,1.24-2.06,4.39-3.44,6.66-2.12,2.42,1.4,2.53,2.6,3.47,4.23s3.23.29,2.28-6.36c4.58-2.26,3.64-9.87,6.07-13,3.79-5,10.28-3.88,12.41-2.79a8.6,8.6,0,0,1,8.79-.78c3.15,1.56,6.16,4.63,7,16.77S206.17,113,203.83,116c-1.71,2.2-5.13,4.7-10.62,4.8l.14,4.55s12.82,12.48-3.14,11.73c-12-.57-18.88-9.59-18.88-9.59v-18.3S171.11,110.63,168.74,111.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.27,
    cy: 99.04,
    r: 3.85,
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,98.55a3.81,3.81,0,0,0,5.63,3.39c0-2-.08-4.32-.26-6.9v0a3.7,3.7,0,0,0-1.52-.32A3.85,3.85,0,0,0,201.23,98.55Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.72,95.75a2,2,0,1,1-2-2A2,2,0,0,1,186.72,95.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.54,
    cy: 95.19,
    r: 2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.85,108.33a3.56,3.56,0,0,1-4.11,2.85,3.5,3.5,0,0,1-2.9-4Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.85,108.28a3.5,3.5,0,0,0,2.89,2.9,3.8,3.8,0,0,0,1.26,0A3.61,3.61,0,0,0,187.85,108.28Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.33,88.53l-4.63-1.38a2.35,2.35,0,0,1,3-1.64A2.48,2.48,0,0,1,203.33,88.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.16,87.3l-4.86,1.79a2.43,2.43,0,0,1,1.41-3.27A2.75,2.75,0,0,1,186.16,87.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.45,89.5l-.91-.07c-2.94-.19-6.77-.13-9,.63-2.83,1-3.79,1.93-5.39,2s-2.85-.84-6-1.55c-2.5-.57-6.58-.32-9.69.1l-1,.14a1.44,1.44,0,0,0-1,1.57,3.52,3.52,0,0,0,1,1.75,2,2,0,0,1,.36.7c.41,1.22.77,3.58,1.49,4.86a6.52,6.52,0,0,0,1.35,1.72,6.86,6.86,0,0,0,.67.5l.38.22a6,6,0,0,0,1.11.44l.19,0,.29.07a2.84,2.84,0,0,0,.31.06,9,9,0,0,0,1,.11l.41,0h.51c4-.14,5.52-2,6.39-3.91s.45-4.52,2.28-4.58h.17l.17,0c1.37.25,1.36,2.66,2.32,4.37a7.46,7.46,0,0,0,1.41,1.84l.33.29.18.13.18.12.16.11.18.1.14.08.1.05a6.17,6.17,0,0,0,1.62.55l.15,0a8.49,8.49,0,0,0,1.94.11c3.72-.16,4.87-2.29,5.4-3.63a29.71,29.71,0,0,0,.82-5,1.35,1.35,0,0,1,.3-.66,3.25,3.25,0,0,0,.72-1.85A1.53,1.53,0,0,0,208.45,89.5Zm-18.61,7.69a5.28,5.28,0,0,1-1.22,2.65h0a5.62,5.62,0,0,1-4.23,1.65,5.08,5.08,0,0,1-4.28-1.73l-.15-.18-.13-.18-.11-.17a.86.86,0,0,1-.1-.16l-.07-.12-.06-.11-.1-.18h0c-.09-.19-.17-.36-.24-.54h0l-.12-.32c-.07-.19-.12-.37-.17-.52l0-.1,0-.1c-.39-1.29-.91-3.83-.27-4.43s2.42-1.27,5.39-1.11h.32c.46,0,.91.09,1.36.17l.54.1a12.44,12.44,0,0,1,1.34.36l.41.14.45.18.09.05.16.07a2.81,2.81,0,0,1,.93.65C190.15,94,190.08,95.73,189.84,97.19ZM207.05,96c-.17,1-.52,3.24-2.53,4.28a5.48,5.48,0,0,1-2.17.54A5,5,0,0,1,197.81,99h0l-.09-.12-.1-.14a.43.43,0,0,1,0-.07,1.37,1.37,0,0,1-.13-.2l-.13-.23a.75.75,0,0,1-.07-.12l0-.06a1,1,0,0,0,0-.1.43.43,0,0,0,0-.07,8.09,8.09,0,0,1-.34-1c-.4-1.44-.66-3.12-.16-3.94s2.63-1.78,4.72-2.11c.48-.08.93-.12,1.35-.15h1.2l.37,0a6.45,6.45,0,0,1,.69.09l.17,0h0l.11,0,.16,0,.2.06a2.55,2.55,0,0,1,.33.11l.06,0a2.78,2.78,0,0,1,.76.41C207.45,92.08,207.25,94.65,207.05,96Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.69,102.68l-6.76,2.84L191.52,97c.26-1.27.51-2.58,1.62-2.68Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.22,90.85,166.57,97a11.59,11.59,0,0,1,1.64,1.22L176.62,93Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,120.78c-6.24-.07-16.59-2.57-19.88-9.78.42,7.13,8.27,10.75,11.79,11.63a34.93,34.93,0,0,0,8.18,1Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.39,96.31s4.72-8.6,13.52-12.33,18.61-.26,18.61-.26,4.47-2.67,8.74-2,5.93,2.66,5.93,2.66l-4-13.76s-4.69-5.69-18-4.66C171.6,67,161.93,73.22,157.83,82Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee-cup--inject-248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee-cup--inject-248"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.23,308.8c12.55,7.25,12.55,19,0,26.25s-32.91,7.25-45.47,0-12.56-19,0-26.25S100.67,301.55,113.23,308.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.69,288.71c-12.81-7.4-33.58-7.4-46.39,0-6.85,4-10,9.23-9.55,14.41h0l7,81.6h0c.3,3.57,2.81,7.09,7.53,9.81,10.08,5.82,26.43,5.82,36.51,0,4.72-2.72,7.23-6.24,7.53-9.81h0l7-81.61h0C123.72,297.94,120.54,292.67,113.69,288.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.69,288.71c-10.56-6.1-26.52-7.16-39-3.21h0c-1,.33-2.06.7-3,1.1l-.31.12-.67.29-.57.26-.55.25-.71.36-.42.21c-.37.2-.75.4-1.11.61-6.85,4-10,9.23-9.55,14.41h0l7,81.6h0c.3,3.57,2.81,7.09,7.53,9.81a34.72,34.72,0,0,0,13.5,4.11c-4.23-1.93-7.45-5.07-7.61-10.15-.11-3.37-.32-9.55-.57-16.82,11,3.1,24.61,2,33.74-3.25a19.12,19.12,0,0,0,6.91-6.31l2.69-31.48a20.86,20.86,0,0,1-7.67,7.09c-9.93,5.73-24.75,6.92-36.72,3.59-.25-7.17-.46-13.18-.57-16.35,13.38,3.35,29.51,1.87,40.44-4.45a28.32,28.32,0,0,0,5.75-4.29l1.12-13.11h0C123.72,297.94,120.54,292.67,113.69,288.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.49,
    cy: 302.1,
    rx: 32.8,
    ry: 18.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,280.09c-14.29-8.26-37.48-8.26-51.78,0-7.14,4.12-10.71,9.53-10.72,14.93v6.44c0,5.4,3.6,10.78,10.72,14.9,14.3,8.25,37.49,8.25,51.78,0,7.16-4.13,10.73-9.55,10.72-15v-6.35C127.11,289.63,123.54,284.22,116.38,280.09Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,280.09c-14.29-8.26-37.48-8.26-51.78,0-7.14,4.12-10.71,9.53-10.72,14.93v6.44c0,5.4,3.6,10.78,10.72,14.9,14.3,8.25,37.49,8.25,51.78,0,7.16-4.13,10.73-9.55,10.72-15v-6.35C127.11,289.63,123.54,284.22,116.38,280.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.85,275.66a44.14,44.14,0,0,0-11.25,4.43c-7.14,4.12-10.71,9.53-10.72,14.93v6.44c0,5.4,3.6,10.78,10.72,14.9a44.14,44.14,0,0,0,11.25,4.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.49,
    cy: 295.03,
    rx: 36.62,
    ry: 21.14,
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,292.73h0L122,281.91h0c-.45-4.07-3.51-8.06-9.19-11.17-12.34-6.75-32.35-6.75-44.69,0-5.68,3.11-8.74,7.1-9.19,11.17h0l-1.23,10.82h0c-.53,4.88,2.61,9.85,9.42,13.58,12.66,6.92,34,6.92,46.66,0C120.63,302.58,123.76,297.61,123.24,292.73Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.24,292.73h0L122,281.91h0c-.45-4.07-3.51-8.06-9.19-11.17-12.34-6.75-32.35-6.75-44.69,0-5.68,3.11-8.74,7.1-9.19,11.17h0l-1.23,10.82h0c-.53,4.88,2.61,9.85,9.42,13.58,12.66,6.92,34,6.92,46.66,0C120.63,302.58,123.76,297.61,123.24,292.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.15,270.74c-5.68,3.11-8.74,7.1-9.19,11.17h0l-1.23,10.82h0c-.53,4.88,2.61,9.85,9.42,13.58a39.46,39.46,0,0,0,8.7,3.37l.77-12.87,1.51-29.75A39.15,39.15,0,0,0,68.15,270.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.49,
    cy: 282.96,
    rx: 31.6,
    ry: 17.29,
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.49,
    cy: 282.96,
    rx: 27.24,
    ry: 13.56,
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.49,
    cy: 282.96,
    rx: 27.24,
    ry: 13.56,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76,280.41c-10.64-5.3-27.89-5.3-38.53,0-3.5,1.74-5.85,3.85-7,6.07,1.19,2.23,3.54,4.33,7,6.08,10.64,5.29,27.89,5.29,38.53,0,3.5-1.75,5.84-3.85,7-6.08C115.6,284.26,113.26,282.15,109.76,280.41Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76,280.41c-10.64-5.3-27.89-5.3-38.53,0-3.5,1.74-5.85,3.85-7,6.07,1.19,2.23,3.54,4.33,7,6.08,10.64,5.29,27.89,5.29,38.53,0,3.5-1.75,5.84-3.85,7-6.08C115.6,284.26,113.26,282.15,109.76,280.41Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.59,277.23l-32.1,18.54a38.31,38.31,0,0,1-10.26-3.21c-4.94-2.46-7.59-5.64-7.94-8.86.35-3.22,3-6.39,7.94-8.86,10.64-5.29,27.89-5.29,38.53,0A22.51,22.51,0,0,1,113.59,277.23Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.59,277.23l-32.1,18.54a38.31,38.31,0,0,1-10.26-3.21c-4.94-2.46-7.59-5.64-7.94-8.86.35-3.22,3-6.39,7.94-8.86,10.64-5.29,27.89-5.29,38.53,0A22.51,22.51,0,0,1,113.59,277.23Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6,284.72l-20,11.57a53.82,53.82,0,0,1-14.08-.52l32.1-18.54Z",
    style: {
      fill: "#FFAA28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6,284.72l-20,11.57a53.82,53.82,0,0,1-14.08-.52l32.1-18.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,292.81l-4.63,2.67a1.92,1.92,0,0,1-1.71-.07h0c-.51-.29-.56-.73-.12-1l4.63-2.67a1.9,1.9,0,0,1,1.7.07h0C115.26,292.11,115.31,292.56,114.88,292.81Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,322.88l-2.72,31.67c-.33,4.07-3.19,8.09-8.58,11.2-11.49,6.64-30.12,6.64-41.61,0-5.76-3.32-8.63-7.68-8.62-12L58.4,323c.44,4.39,3.56,8.69,9.36,12,12.56,7.25,32.91,7.25,45.47,0,5.85-3.38,9-7.74,9.37-12.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.89,349.14a14.67,14.67,0,0,1,4.32-2.8.84.84,0,0,0,.07-1.52c-3.14-1.56-7.55-.53-10.67,2.73-3.29,3.45-4,8.18-1.85,11.2a.86.86,0,0,0,1.21.15,12.78,12.78,0,0,0,3.86-5.36A12.87,12.87,0,0,1,107.89,349.14Zm7.11-1.65a.87.87,0,0,0-1.1-.36,13.38,13.38,0,0,0-6.8,6.27,37.9,37.9,0,0,1-2.28,4.55,8.76,8.76,0,0,1-2.58,2.44c-.14.08-.08.42.1.5,3.11,1.35,7.36.29,10.38-2.87S116.59,350.51,115,347.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,339a38.85,38.85,0,0,1-10.25-4c-5.8-3.35-8.92-7.65-9.36-12l2.67,30.7c0,4.36,2.86,8.72,8.62,12a35.51,35.51,0,0,0,9.4,3.65Z",
    style: {
      fill: "#37474f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeprojectAmico);
export default __webpack_public_path__ + "static/media/college project-amico.8ce69244d57c771ed41ecdbb6796529d.svg";
export { ForwardRef as ReactComponent };